





































































































































































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
import store from '@/store'
import headers from './headers'
import headersEan from './headersEan'
import headersValue from './headersValue'
import moment from 'moment'
import Dialog from '../Dialog.vue'
import { ITranscoHyperProxi } from '../../store/modules/transco-hyper-proxi/types'

@Component<TranscoProductsDataTable>({})
export default class TranscoProductsDataTable extends Vue {
  @Prop({ default: () => [] })
  private sortBy: any

  @Prop({ default: () => [] })
  private sortDesc: any

  private headers: any
  private headersValue: any
  private headersEan: any
  private editedItem: any
  private defaultItem: any
  private itemsPerPage: number
  private alertMessage: string
  private color: string
  private hideEan: boolean
  private page: number
  private pageCount: number
  private items: string[]
  private validSearch: boolean
  private rules: {}

  public constructor() {
    super()

    this.headers = headers
    this.headersValue = headersValue
    this.headersEan = headersEan
    this.items =
      store.getters['transcoHyperProxi/getAllTranscoHyperProxisProducts']
    this.itemsPerPage = store.getters.parameters('itemsPerPage')
    this.editedItem = {}
    this.defaultItem = {}
    this.alertMessage = ''
    this.color = '#4CAF50'
    this.hideEan = true
    this.page = 1
    this.pageCount = 0
    this.validSearch = false
    this.rules = {
      searchRules: [
        (v: string) => (v && v.trim().length >= 3) || '3 caractères minimum.',
        (v: string) => (v && v.trim().length <= 30) || '30 caractères maximum.',
      ],
    }
  }

  public async mounted(item: any) {
    this.headers = headers
  }

  get productSearch() {
    return this.$store.getters['transcoHyperProxi/productSearch']
  }

  set productSearch(value) {
    this.$store.dispatch('transcoHyperProxi/updateProductSearch', value)
  }

  get transcoHyperProxiData() {
    return store.getters['transcoHyperProxi/getAllTranscoHyperProxisProducts']
  }

  get isLoading() {
    return this.$store.getters['transcoHyperProxi/isLoading']
  }

  public validateSearch() {
    this.validSearch = (this.$refs.searchForm as Vue & {
      validate: () => boolean;
    }).validate()
  }

  public async searchProducts() {
    this.validateSearch()
    if (
      !this.$store.getters['transcoHyperProxi/isLoading'] &&
      this.validSearch
    ) {
      await this.$store.dispatch(
        'transcoHyperProxi/searchProducts',
        this.$store.getters['transcoHyperProxi/productSearch'],
      )
    }
  }

  public momentDate(date: Date) {
    return date ? moment(date).format('DD/MM/YYYY') : ''
  }

  public computedHeaders() {
    this.headers = this.headersValue
  }

  public computedHeadersEan() {
    this.headers = this.headersEan
  }

  public getColor() {
    return 'rgb(255, 255, 255)'
  }
}
